"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function MenuDotsHorizontalIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M7.47,12A2.85,2.85,0,1,1,4.62,9.15,2.854,2.854,0,0,1,7.47,12Zm-4,0a1.151,1.151,0,1,0,1.15-1.15A1.151,1.151,0,0,0,3.47,12Z" }),
        react_1.default.createElement("path", { d: "M14.85,12A2.85,2.85,0,1,1,12,9.15,2.854,2.854,0,0,1,14.85,12Zm-4,0A1.15,1.15,0,1,0,12,10.85,1.151,1.151,0,0,0,10.85,12Z" }),
        react_1.default.createElement("path", { d: "M22.229,12A2.85,2.85,0,1,1,19.38,9.15,2.853,2.853,0,0,1,22.229,12Zm-4,0a1.151,1.151,0,1,0,1.151-1.15A1.152,1.152,0,0,0,18.229,12Z" })));
}
exports.default = MenuDotsHorizontalIcon;
